import React, { useState, useEffect } from "react";

import { Row, Col, FormControl, Checkbox, Grid } from "react-bootstrap";

import { useMultiFilterContext } from "contexts/MultiFilterContext";
import { useEditCoachPoolContext } from "contexts/EditCoachPoolContext";

import FilterGroupTitle from "./FilterGroupTitle.js";
import FilterGroupVisiblePart from "./FilterGroupVisiblePart.js";
import FilterGroupHiddenPart from "./FilterGroupHiddenPart.js";

export default function FilterBlock({ filterWrapper }) {
  const { dispatch, actions, state } = useMultiFilterContext();
  const {
    dispatch: dispatchEditCoachPool,
    actions: actionsEditCoachPool,
    state: stateEditCoachPool,
  } = useEditCoachPoolContext();

  const selectCategory = (category) => {
    actions.selectCategory(dispatch, category);
    actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
  };

  const deselectCategory = (category) => {
    actions.deselectCategory(dispatch, category);
    actionsEditCoachPool.clearSelectedAll(dispatchEditCoachPool);
  };

  return (
    <>
      <div
        className={`dropdown-menu dropdown-search ${filterWrapper.className}`}
      >
        <div className="header">
          <a
            onClick={() => selectCategory(filterWrapper.category)}
            className="select-all"
          >
            Select All
          </a>
          <a
            onClick={() => deselectCategory(filterWrapper.category)}
            className="unselect-all"
          >
            Deselect All
          </a>
        </div>
        {filterWrapper.filters.map((filterGroup, index) => {
          return (
            <div key={index}>
              <div className="content">
                {filterWrapper.filters.length > 1 && (
                  <FilterGroupTitle filterGroup={filterGroup} />
                )}
                <div className="mr20 ml20">
                  <FilterGroupVisiblePart
                    filterWrapper={filterWrapper}
                    filterGroup={filterGroup}
                  />
                </div>
                <FilterGroupHiddenPart
                  filterWrapper={filterWrapper}
                  filterGroup={filterGroup}
                />
              </div>
              {filterWrapper.filters.length > 1 && <hr />}
            </div>
          );
        })}
      </div>
    </>
  );
}
